import { PopoverInteractionKind, Tag, Tooltip } from "@blueprintjs/core";
import { faIdCard } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const TierTagTooltip: React.FC<any> = (props) => {
  return (
    <Tooltip
      boundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      hoverCloseDelay={200}
      content={props.content}
    >
      {props.children}
    </Tooltip>
  );
};

const TierTagBadge: React.FC<any> = (props) => {
  return (
    <Tag
      style={{ marginLeft: "4px" }}
      intent="success"
      minimal
      icon={<FontAwesomeIcon icon={faIdCard} />}
    >
      {props.children}
    </Tag>
  );
};

interface TierTagProps {
  orgName: string;
}

export const CommunityTierTag: React.FC<TierTagProps> = ({ orgName }) => {
  const tooltipContent = (
    <span>
      <strong>{orgName}</strong> is using the Semgrep Community tier.
      <br />
      Click to learn more about upgrading to Semgrep Team!
    </span>
  );
  return (
    <TierTagTooltip content={tooltipContent}>
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a // nosem: typescript.react.security.audit.react-missing-noreferrer.react-missing-noreferrer
        target="_blank"
        rel="noopener noreferrer"
        href="https://semgrep.dev/pricing"
      >
        <TierTagBadge>Community</TierTagBadge>
      </a>
    </TierTagTooltip>
  );
};

export const TeamTierTag: React.FC<TierTagProps> = ({ orgName }) => {
  const tooltipContent = (
    <span>
      <strong>{orgName}</strong> is using the Semgrep Team tier.
    </span>
  );
  return (
    <TierTagTooltip content={tooltipContent}>
      <TierTagBadge>Team</TierTagBadge>
    </TierTagTooltip>
  );
};
